import WhyPodiemFooterCallout from "@/core/infrastructure/repository/why_podiem/WhyPodiemFooterCallout"
import hasData from "@/core/domain/specification/hasData"

export default class WhyPodiemFooterCalloutService {
    whyPodiemFooterCallout: WhyPodiemFooterCallout

    constructor() {
        this.whyPodiemFooterCallout = new WhyPodiemFooterCallout()
    }

    async process() {
        const { data, totalCount } = await this.whyPodiemFooterCallout.fetch()

        if (!hasData(totalCount)) {
            throw new TypeError("No data was provided")
        }

        return data
    }
}
